module.exports = __webpack_public_path__ + "img/013.1dbc78fa.png";